import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';
import { EndPoint } from '../config/endpoint';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private httpService: HttpService) {}

  async getAllRoles() {
    try {
      const roles = await firstValueFrom(this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Role}`));
      return this.httpService.decodeToken(roles);
    } catch (error) {
      throw error;
    }
  }

  async getRolesByRoleIds(body) {
    try {
      const roles = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.get_roles_by_role_id}`, body),
      );
      return this.httpService.decodeToken(roles);
    } catch (error) {
      throw error;
    }
  }
}
